import { Activity, Radio, Users, Tv, Signal, Film, Clapperboard } from "lucide-react";

export default function StatusPanel({ status }) {
  const online = status?.configured;
  const stats = [
    { label: "Channels", value: status?.channel_count ?? 0, icon: Tv },
    { label: "Movies", value: status?.movie_count ?? 0, icon: Film },
    { label: "Series", value: status?.series_count ?? 0, icon: Clapperboard },
  ];

  return (
    <div className="rounded-sm border border-zinc-800 bg-zinc-900 p-6" data-testid="status-panel">
      <div className="mb-5 flex items-center gap-2">
        <Activity className="h-5 w-5 text-emerald-400" />
        <h2 className="font-heading text-lg font-semibold tracking-tight text-zinc-100">Status</h2>
      </div>

      <div className="mb-5 flex items-center justify-between rounded-sm border border-zinc-800 bg-zinc-950 px-4 py-3">
        <span className="flex items-center gap-2 font-mono text-xs uppercase tracking-wider text-zinc-400">
          <Signal className="h-4 w-4" /> Bridge
        </span>
        <span
          data-testid="server-status-badge"
          className={`flex items-center gap-2 rounded-sm border px-2.5 py-1 font-mono text-xs uppercase tracking-wider ${
            online
              ? "border-emerald-500/20 bg-emerald-500/10 text-emerald-400"
              : "border-amber-500/20 bg-amber-500/10 text-amber-500"
          }`}
        >
          <span
            className={`h-1.5 w-1.5 rounded-full ${
              online ? "animate-pulse bg-emerald-400 drop-shadow-[0_0_6px_rgba(16,185,129,0.6)]" : "bg-amber-500"
            }`}
          />
          {online ? "Online" : "Not Configured"}
        </span>
      </div>

      <div className="grid grid-cols-3 gap-3">
        {stats.map((s) => (
          <div key={s.label} className="rounded-sm border border-zinc-800 bg-zinc-950 p-3">
            <s.icon className="mb-2 h-4 w-4 text-zinc-500" />
            <p data-testid={`stat-${s.label.toLowerCase()}`} className="font-heading text-2xl font-bold text-zinc-50">
              {s.value}
            </p>
            <p className="font-mono text-[10px] uppercase tracking-wider text-zinc-500">{s.label}</p>
          </div>
        ))}
      </div>

      <div className="mt-5 space-y-2">
        <Row label="Sessions" value={String(status?.active_sessions ?? 0)} />
        <Row label="Format" value={(status?.stream_format || "ts").toUpperCase()} />
        <Row label="Server ID" value={status?.server_id?.slice(0, 16) || "—"} />
        <Row label="Version" value={status?.version || "—"} />
        <Row label="Panel" value={status?.xtream_url || "not set"} truncate />
      </div>
    </div>
  );
}

function Row({ label, value, truncate }) {
  return (
    <div className="flex items-center justify-between gap-3 border-b border-zinc-800/60 pb-2 last:border-0">
      <span className="font-mono text-[11px] uppercase tracking-wider text-zinc-500">{label}</span>
      <span className={`font-mono text-xs text-zinc-300 ${truncate ? "max-w-[180px] truncate" : ""}`}>{value}</span>
    </div>
  );
}
